import { apiClient } from '@/lib/api/client';
export const aspectsApi = {
    async list(groupId) {
        const { data } = await apiClient.get(`/api/v1/groups/${groupId}/aspects`);
        return data;
    },
    async create(groupId, dto) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/aspects`, dto);
        return data;
    },
    async update(groupId, id, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${groupId}/aspects/${id}`, dto);
        return data;
    },
    async delete(groupId, id) {
        await apiClient.delete(`/api/v1/groups/${groupId}/aspects/${id}`);
    },
};
//# sourceMappingURL=aspects.js.map